import React from "react";
import PropTypes from "prop-types";
import { Badge } from "@fluentui/react-components";

export const FluentBadge = (props) => {
  let { text, ...rest } = props;
  return <Badge {...rest} data-testid="fluent-badge">{text}</Badge>;
};

FluentBadge.propTypes = {
  text: PropTypes.string.isRequired,
};
